<div class="container-fluid p-0 m-0">
    <app-shared status="Valide" type="commande-client"></app-shared>
</div>
